import {useMsal} from '@azure/msal-react';
import {loginRequest} from '../../microsoftAuthConfig';
import {AccountInfo} from '@azure/msal-common';

const useMsalActiveAccount = () => {
    const {instance} = useMsal();
    let activeAccount: AccountInfo;

    if (instance) {
        activeAccount = instance.getActiveAccount();
    }

    const getIdToken = async (): Promise<string> => {
        if (instance && activeAccount) {
            return instance
                .acquireTokenSilent({
                    scopes: [],
                    account: activeAccount,
                })
                .then(res => {
                    return res.idToken;
                })
                .catch(error => {
                    console.error(
                        'Silent token acquisition failed, acquiring token using redirect',
                        error,
                    );
                    instance.acquireTokenRedirect({
                        scopes: [],
                        account: activeAccount,
                    });
                    return null;
                });
        }
    };

    return {activeAccount, getIdToken};
};

export default useMsalActiveAccount;
